import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { IViewData, IGeoChartSettings } from "../../scripts/ah.mb.ui.view-builders"
import { ConvergenceServices } from "../../scripts/ah.mb.convergence-services";
import { GoogleChartRenderer } from "../../scripts/ah.mb.googleChartRenderer";


@Component
export default class ConvergenceGraph extends Vue {

    @Prop()
    jobId: string;

    timeoutId: number;


    showAsTable: boolean = false;

    // Create convergenceServices
    private convergenceServices = new ConvergenceServices();
    private chartRenderer = new GoogleChartRenderer();

    // Data for chart
    private chartData = null;

    private tableView = false;

    mounted() {
        this.chartRenderer.loadGoogleLibraries(() => {
            this.callChartUpdate(this.jobId);
        });


    }

    @Watch("jobId")
    jobIdChanged() {

        if (this.timeoutId)
            clearTimeout(this.timeoutId);
        this.startRefreshTimer();
    }

    // Renders convergence chart
    callChartUpdate(selectedJobId) {

        if (selectedJobId)
        //if (!selectedJobId) {
        //    // Clear the svg
        //    d3.selectAll("svg > *").remove();
        //    return;


        // Get job containing iterations/error info
        this.convergenceServices.getJob(selectedJobId).then(
            (jobData) => {

                if (jobData.outcome === "Running") {
                    // console.log(jobData.convergenceResult);

                    const iters = jobData.iterationsExecuted;
                    const modelId = jobData.modelId;

                    const isNew = !this.chartData;
                    // First iteration: create columns
                    if (isNew) {

                        this.chartData = new google.visualization.DataTable();
                        this.chartData.addColumn("number", "Iterations");
                        jobData.errorMetrics.forEach((errorMetric) => {

                            this.chartData.addColumn("number", errorMetric.key);
                        });

                    }

                    // Add current iteration data to array
                    var row = [iters];
                    jobData.errorMetrics.forEach(errorMetric => {
                        if (isNaN(errorMetric.value))
                            row.push(-1);
                        else
                        row.push(errorMetric.value);
                    });
                    this.chartData.addRow(row);

                    if (iters > 1) {
                        $("#chartHeader")
                            .text(
                                "Model: " +
                                modelId +
                                ", Iterations Executed: " +
                                iters.toString() +
                                ", Model Error: " +
                                jobData.modelError.toExponential());



                        if (isNew || (this.showAsTable !== this.tableView)) {
                            this.tableView = this.showAsTable;
                            this.redrawChart(this.chartData);
                        } else {
                            //chartRenderer.chartInstance.setOptions(
                            //    { "options.vAxis.viewWindow": 100 });
                            this.chartRenderer.refresh();
                        }
                    }

                    //// Max 1000 data points
                    //if (chartData.length > 1000)
                    //    chartData = chartData.slice(chartData.length - 1000, chartData.length - 1);
                    this.startRefreshTimer();
                } else {

                    $("#chartHeader")
                        .text("Job not found, or not currently running");
                }
            });
    }

    redrawChart(chartData) {

        const asTable = $("#showAsTableCheckbox").is(":checked");
        var geoChartSettings: IGeoChartSettings = { regionCode: "", resolution: "countries" };

        const viewData: IViewData = {
            title: "Convergence Graph",
            //result: null, //  Array < IViewDataRecord > ,
            failText: "",
            yAxisDataType: "Absolute Error",
            xAxisDataType: "Iterations",
            dataType: "Double",
            chartData: chartData,
            chartOptions: {
                seriesType: asTable ? 4 : 1,
                isStacked: false
            },
            isRawData: true,
            geoChartSettings

        };

        //if (chartRenderer.chartInstance) {

        //    // Chart already exists: update it

        //    d3.select('#chartDiv svg')
        //        .datum(chartData)
        //        .transition()
        //        .duration(duration)
        //        .call(chartRenderer.chartInstance);

        //    //nv.utils.windowResize(chartRenderer.chartInstance);

        //} else {

        // New chart


        this.chartRenderer.drawGraph(
            $("#chartDiv"),
            viewData,
            {
                showLegend: true,
                showTitle: false,
                showXAxisTitlesFunc: title => true,
                showYAxisTitlesFunc: title => true,
                backgroundColor: "white"

            }
        );
    }

    startRefreshTimer() {
        if (this.jobId)
            // Set refresh interval
            window.setTimeout(() => {
                // Only if viewing first page, or it jumps about
                this.callChartUpdate(this.jobId);
            },
            2500);

    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/convergence-graph/convergence-graph.ts